import type { DateIso } from '../../../types/domain';
import { dateFromIso, isoStr } from '../base';
import { contractMonthStart, contractPeriodEnd, contractTotalMonths } from './months';

// Mois du contrat déjà commencés à la date donnée (un mois commencé compte), sans dépasser la fin.
export function contractMonthsElapsed(
  startIso: DateIso | null | undefined,
  endIso: DateIso | null | undefined,
  todayIso: DateIso,
): number {
  if (!startIso || startIso > todayIso) return 0;
  return contractTotalMonths(startIso, endIso && endIso < todayIso ? endIso : todayIso);
}

/** Année de contrat : période de 12 mois anniversaires, bornée par la fin du contrat. */
export interface ContractYear {
  from: DateIso;
  to: DateIso;
  months: number;
}

/* Année de contrat en cours (15/10/2025 → 14/10/2026, puis 15/10/2026 → 14/10/2027…) : sert aux
   quotas annuels de maintenance et à la marge de l'année. null avant le début du contrat. */
export function currentContractYear(
  startIso: DateIso | null | undefined,
  endIso: DateIso | null | undefined,
  todayIso: DateIso,
): ContractYear | null {
  const elapsed = contractMonthsElapsed(startIso, endIso, todayIso);
  if (!startIso || !elapsed) return null;
  const start = dateFromIso(startIso);
  const k = Math.floor((elapsed - 1) / 12) * 12;
  const periodEnd = isoStr(contractPeriodEnd(start, k + 12));
  const to = endIso && endIso < periodEnd ? endIso : periodEnd;
  const from = isoStr(contractMonthStart(start, k));
  return { from, to, months: contractTotalMonths(from, to) };
}
